var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_114_11371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 31.0254L15.723 26.4246C15.4987 26.276 15.3221 26.085 15.1932 25.8518C15.0644 25.6185 15 25.3731 15 25.1154V14.6618C15 14.2045 15.175 13.8175 15.525 13.5006C15.875 13.1838 16.3026 13.0254 16.8077 13.0254H28.1923C28.6974 13.0254 29.125 13.1838 29.475 13.5006C29.825 13.8175 30 14.2045 30 14.6618V25.1154C30 25.3731 29.9356 25.6185 29.8068 25.8518C29.6779 26.085 29.5013 26.276 29.277 26.4246L22.5 31.0254ZM22.5 29.3195L28.375 25.3331C28.4135 25.304 28.4439 25.2706 28.4663 25.2328C28.4888 25.1951 28.5 25.1531 28.5 25.1068V14.6618C28.5 14.5921 28.4679 14.5283 28.4038 14.4704C28.3398 14.4123 28.2692 14.3832 28.1923 14.3832H16.8077C16.7307 14.3832 16.6603 14.4123 16.5963 14.4704C16.5321 14.5283 16.5 14.5921 16.5 14.6618V25.1068C16.5 25.1531 16.5113 25.1951 16.5338 25.2328C16.5561 25.2706 16.5865 25.304 16.625 25.3331L22.5 29.3195ZM21.45 24.0273L26.7538 19.2262L25.7 18.2445L21.45 22.0917L19.3308 20.1733L18.2463 21.1272L21.45 24.0273ZM22.5 14.3832H16.5H28.5H22.5Z",
    fill: "#CCCCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_114_11371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(13 13.0254)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecking);
export default __webpack_public_path__ + "static/media/checking.0eb9aefb8747b9b7543cc2d02ede3df0.svg";
export { ForwardRef as ReactComponent };